<template>
  <div class="ml-2 mr-2">
    <v-text-field class="input-text-size pa-0" label="Fire District"
    v-model="editedItem.fireDistrict" />
    <v-text-field class="input-text-size pa-0" label="Millage"
    v-model.number="editedItem.millage" type="number" />
    <CommonDropDowns class="input-text-size pa-0" :isItTaxDistrict=true
    taxDistrictNameOverride="originalTaxDistrict" taxDistrictLabelOverride="Original Tax District"
    @change="dataFromCommonDropDowns" :taxDistrictValue="editedItem.originalTaxDistrict" />
    <CommonDropDowns class="input-text-size pa-0" :isItTaxDistrict=true
    taxDistrictNameOverride="taxDistrictWithFire" taxDistrictLabelOverride="Tax District with Fire"
    @change="dataFromCommonDropDowns" :taxDistrictValue="editedItem.taxDistrictWithFire" />
    <v-checkbox class="input-text-size pa-0" dense v-model="editedItem.isItSaForTulsa"
    hide-details label="Sa For Tulsa" />
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';

export default {
  name: 'assessorFireTaxXRefDialog',
  components: {
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'assessorFireTaxXRef',
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
  },
};
</script>
